import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardShadowColumns';
import { MarketingHubEnterpriseProductIcon, MarketingHubProfessionalProductIcon, MarketingHubStarterProductIcon } from 'pricing-pages-ui-components/productIcon/MarketingProductIcons';
import { HubCardBadge } from '../../../components/common/badges/HubCardBadge';
import { useHandleClickFreeToolsWithLimitsLink } from '../../components/merch-card/feature-display/useHandleClickFreeToolsWithLimitsLink';
import { HubMerchCard } from '../../containers/merch-card/cards/HubMerchCard';
import { PriorityFeaturesByProductApiName } from '../../containers/merch-card/features-display/PriorityFeaturesByProductApiName';
import { useIsFreePortal } from '../../hooks/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MarketingHubMerchCards = () => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const handleClickFreeToolsWithLimitsLink = useHandleClickFreeToolsWithLimitsLink();
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardColumns, {
      columns: 3,
      children: [/*#__PURE__*/_jsx(HubMerchCard, {
        apiName: "marketing-hub-starter",
        columnStart: 1,
        ProductIcon: /*#__PURE__*/_jsx(MarketingHubStarterProductIcon, {}),
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.starterCard.title"
        }),
        Badge: /*#__PURE__*/_jsx(HubCardBadge, {
          productLine: "MARKETING",
          productLevel: "STARTER"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.starterCard.description"
        }),
        Features: /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
            productApiName: "marketing-hub-starter",
            lowerTierMessage: isFreePortal && !isInventoryLoading ? /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsPlus",
              options: {
                freeToolsWithIncreasedLimits: /*#__PURE__*/_jsx(Link, {
                  onClick: handleClickFreeToolsWithLimitsLink,
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "pricing-pages-ui.merchCardsV2.priorityFeatures.freeToolsWithLimits"
                  })
                })
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.starter.lowerTierPlus"
            })
          })
        })
      }), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: "marketing-hub-professional",
        columnStart: 2,
        ProductIcon: /*#__PURE__*/_jsx(MarketingHubProfessionalProductIcon, {}),
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.professionalCard.title"
        }),
        Badge: /*#__PURE__*/_jsx(HubCardBadge, {
          productLine: "MARKETING",
          productLevel: "PROFESSIONAL"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.professionalCard.description"
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: "marketing-hub-professional",
          lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.professional.lowerTierPlus"
          })
        })
      }), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: "marketing-hub-enterprise",
        columnStart: 3,
        ProductIcon: /*#__PURE__*/_jsx(MarketingHubEnterpriseProductIcon, {}),
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.enterpriseCard.title"
        }),
        Badge: /*#__PURE__*/_jsx(HubCardBadge, {
          productLine: "MARKETING",
          productLevel: "ENTERPRISE"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.marketing.enterpriseCard.description"
        }),
        Features: /*#__PURE__*/_jsx(PriorityFeaturesByProductApiName, {
          productApiName: "marketing-hub-enterprise",
          lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.enterprise.lowerTierPlus"
          })
        })
      })]
    })
  });
};